/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { BtnAnch } from 'components/elements/global'
import { useSendMessageMutation } from 'features/chat/api'

import { TPostChatMessage } from 'features/chat/types'
import useAuth from 'hooks/useAuth'
import { FC, useState } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { CHAT_INPUT_ID } from 'features/chat/chatConstants'
import { baseTime } from 'lib'

const ChatMsgFooter: FC<{
 id?: string | number
 onSendMsg?: () => void
}> = ({ id, onSendMsg }) => {
 const [message, setMessage] = useState<string>('')
 const { user } = useAuth()
 const [sendMessage] = useSendMessageMutation()

 const handleSubmitMsg = async (val?: TPostChatMessage) => {
  const tempId = `tem-${baseTime().valueOf()}-${user?.id}`
  await sendMessage({
   lead_id: id as any,
   message: val?.message,
   temp_id: tempId,
  }).unwrap()

  onSendMsg?.()
 }

 const onEnterPress = (e?: any) => {
  if (e.keyCode == 13 && e.shiftKey == false) {
   e.preventDefault()
   if (message.trim()) {
    handleSubmitMsg?.({ message })
    setMessage('')
   }
  }
 }

 return (
  <footer className="chat-msg-footer">
   <div className="input--block-chat">
    <TextareaAutosize
     id={CHAT_INPUT_ID}
     value={message}
     onKeyDown={onEnterPress}
     onChange={(e) => setMessage(`${e.target.value}`)}
     placeholder="Type a message"
     minRows={1}
     maxRows={5}
     className="form-control"
    />
    <BtnAnch
     onClick={() => handleSubmitMsg({ message })}
     className="cht-btn-ico"
    >
     <i className="far fa-paper-plane" />
    </BtnAnch>
   </div>
  </footer>
 )
}

export default ChatMsgFooter
